// Resolve a pending manual-promotion decision on a pipeline
// (POST /pipelines/:id/promotion-decision, action: 'promote' | 'dismiss').
const action = "MODEL_PROMOTION_DECISION";
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

// payload: { modelId, decision: 'promote' | 'dismiss' }
export const fetchRequest = (payload) => ({ type: REQUEST, payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error) => ({ type: FAILURE, payload: error });
export const clearState = () => ({ type: CLEAR });
